import { get } from "lodash"
import { createSelector } from "reselect"
import { computeSort } from "helpers/securities-search"
import { getModelTopFactors } from "selectors/modelMetadata"
import { getMissingDataFiles } from "selectors/missingDataFiles"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeSelectedColumns } from "selectors/securities-table"

export const getHistoricalFactorSensitivityIsAvailable = state => get(state, "global.data.historicalFactorSensitivityAvailability.data")
export const getPage = state => get(state, "modules.securitiesFinder.page", 0)
export const getModuleSelectedColumns = state => get(state, "modules.securitiesFinder.selectedColumns")
const getRawSort = state => get(state, "modules.securitiesFinder.sort")
const getModelId = (_, props) => get(props, "modelId")

export const getSort = createSelector(
  [getRawSort, getMissingDataFiles, getModelId, getIsOpPro],
  computeSort,
)

export const getSelectedColumns = createSelector(
  [getModuleSelectedColumns, getModelTopFactors, getMissingDataFiles, getModelId, getIsOpPro],
  computeSelectedColumns,
)
